export type StepKey = "plan" | "addons" | "payment";

export type PlanPurchaseMode = "upgrade" | "addon_only" | "renew";

export const getStepsForMode = (mode: PlanPurchaseMode): StepKey[] =>
  mode === "addon_only" ? ["addons", "payment"] : ["plan", "addons", "payment"];
